// @flow

import React from 'react';
import classNames from 'classnames';
import red from '@mui/material/colors/red';
import { log } from '../../utils/jsUtils';
import { useSelector } from 'react-redux';
import { selectI18n } from '../../reduxStore/modules/common/selectors';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import TagRenderer from '../SharedComponents/TagRenderer';

import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/ConfirmRemoveTagDialog.Style';
import type { Tag } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  open: boolean,
  actionConfirm: Function,
  tag: Tag
}

const ConfirmRemoveTagDialog = (props: Props) => {
  const {
    setOpen,
    open,
    actionConfirm,
    tag
  } = props;
  
  const i18n = useSelector(selectI18n);
  const theme = useTheme();
  const classes = createClasses(styles, theme);

  return (
    <div>
    {
      (tag !== null && typeof tag !== 'undefined')
      ? <Dialog
          aria-labelledby='form-add-property'
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'HEADS UP!'}
          </DialogTitle>
          <DialogContent style={{ ...classes.grow, ...classes.flexContainer }}>
            <DialogContentText>
              {'You are about to remove this tag from your account.'}<br />
              {'Customer profiles will also be updated to remove this tag.'}
            </DialogContentText>
              <div style={classes.tagCtr}>
                <TagRenderer
                  readonly
                  tagsIds={[tag._id]}
                />
              </div>
              {'Are you sure?'}
          </DialogContent>
          <DialogActions>
            <Button 
              color='primary'
              onClick={() => setOpen(false)}
              type='button'
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { 
                actionConfirm(tag); 
                setOpen(false); 
                }
              }
              variant='contained'
            >
              {'Remove'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </div>
  );
};

export default ConfirmRemoveTagDialog;